var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgP8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0898 12.8906H17.8689C17.3308 11.3693 15.873 10.3125 14.2227 10.3125C12.5616 10.3125 11.0963 11.3832 10.5663 12.9196C9.20674 13.1034 8.11345 14.1388 7.84218 15.4688H7.77734C6.35546 15.4688 5.19922 16.625 5.19922 18.0469C5.19922 19.4688 6.35546 20.625 7.77734 20.625H18.0898C20.2223 20.625 22 18.8903 22 16.7578C22 14.6253 20.2223 12.8906 18.0898 12.8906ZM16.8008 0H0V5.15625H16.8008V0ZM3.91016 3.86719H2.62109V2.57812H3.91016V3.86719ZM6.48828 3.86719H5.19922V2.57812H6.48828V3.86719ZM9.06641 3.86719H7.77734V2.57812H9.06641V3.86719ZM14.2227 9.02344C15.1488 9.02344 16.0331 9.27433 16.8008 9.71863V6.44531H0V10.3125H10.8271C11.7474 9.50495 12.9413 9.02344 14.2227 9.02344ZM3.91016 9.02344H2.62109V7.73438H3.91016V9.02344ZM6.48828 9.02344H5.19922V7.73438H6.48828V9.02344ZM9.06641 9.02344H7.77734V7.73438H9.06641V9.02344ZM6.8741 14.2861C7.39716 13.1059 8.40675 12.1995 9.64292 11.8099C9.6806 11.7371 9.72877 11.6721 9.76968 11.6016H0V16.7578H4.13196C4.56564 15.535 5.59724 14.5927 6.8741 14.2861ZM5.19922 12.8906H6.48828V14.1797H5.19922V12.8906ZM3.91016 14.1797H2.62109V12.8906H3.91016V14.1797Z",
    fill: "#1885CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP8);
export default __webpack_public_path__ + "static/media/p8.473929e816469569b14c61c58f6ca558.svg";
export { ForwardRef as ReactComponent };